import React from 'react'
import GridContainer from '../../../Components/UiKits/Grid'

export default function Grid() {
  return (
    <div className='page-body'>
        <GridContainer/>
    </div>
  )
}
